import { Controller } from 'stimulus';

export default class FilterResultsController extends Controller {
  clearFilters() {
    const url = new URL(window.location.href);

    [...url.searchParams.keys()].forEach((key) => {
      if (key.startsWith('filters[')) {
        url.searchParams.delete(key);
      }
    });

    window.location.href = url.toString();
  }
}
